import GameDevCoursePage from "./gameDevCoursePage"

export default GameDevCoursePage;